import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { PageMenu as View } from './PageMenu'

export const PageMenu = withStyles(styles)(View)
